import { render, staticRenderFns } from "./ConfigInputOption.vue?vue&type=template&id=5680d81a&"
import script from "./ConfigInputOption.vue?vue&type=script&lang=js&"
export * from "./ConfigInputOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5680d81a')) {
      api.createRecord('5680d81a', component.options)
    } else {
      api.reload('5680d81a', component.options)
    }
    module.hot.accept("./ConfigInputOption.vue?vue&type=template&id=5680d81a&", function () {
      api.rerender('5680d81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputOption.vue"
export default component.exports